
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.682 12c0 5.347-4.334 9.682-9.682 9.682-5.347 0-9.682-4.335-9.682-9.682S8.653 2.318 14 2.318c5.348 0 9.682 4.335 9.682 9.682z","stroke":"#fff"}}),_c('path',{attrs:{"d":"M9.781 6A4.781 4.781 0 11.219 6a4.781 4.781 0 019.562 0zM27.781 6a4.781 4.781 0 11-9.562 0 4.781 4.781 0 019.562 0zM18.781 22a4.781 4.781 0 11-9.562 0 4.781 4.781 0 019.562 0z","fill":"#fff","stroke":"#fff","stroke-width":".438"}})])
          )
        }
      }
    